// utils/metadata.ts
type PageMetadataType = Record<
  string,
  {
    title: string;
    description: string;
    icons?: { icon: string; apple: string };
  }
>;
export const metadataDictionary: PageMetadataType = {
  home: {
    title: 'Partsflow | Home | AI CRM Whatsapp Backoffice',
    description: 'Partsflow AI CRM Whatsapp Backoffice platform',
  },
  stats: {
    title: 'Partsflow | Analytics',
    description: 'View and manage your business data',
  },
  stats_marketing: {
    title: 'Partsflow | Marketing',
    description: 'Marketing campaign performance dashboard',
  },
  monthly_report: {
    title: 'Partsflow | Reporte Mensual',
    description: 'Visión ejecutiva mensual del canal digital',
  },
  out_of_stock_report: {
    title: 'Partsflow | Repuestos sin stock',
    description: 'Reporte de repuestos sin stock y pérdida de venta estimada',
  },
  sales_report: {
    title: 'Partsflow | Reporte de Ventas',
    description:
      'Reporte de ventas registradas manualmente o detectadas por IA',
  },
  crm: {
    title: 'Partsflow | CRM',
    description: 'Manage your clients in the CRM.',
  },
  crm_chat: {
    title: 'Partsflow | Chat | CRM',
    description: 'Manage your chats in the CRM.',
  },
  crm_contact_list: {
    title: 'Partsflow | Contact List | CRM',
    description: 'Manage your contact list in the CRM.',
  },
  orders: {
    title: 'Partsflow | Orders',
    description: 'Manage and track orders.',
  },
  kanban: {
    title: 'Partsflow | Kanban',
    description: 'Manage and track orders.',
  },
  settings_codes: {
    title: 'Partsflow | Códigos',
    description: 'Manage every car code',
  },
  automations_part_codes: {
    title: 'Partsflow | Códigos de parte',
    description: 'Review OEM code segments by brand and canonical product',
  },
  settings_users_list: {
    title: 'Partsflow | Usuarios',
    description: 'Manage your users',
  },
  settings_chats: {
    title: 'Partsflow | Chats',
    description: 'Manage your chats',
  },
  settings_catalogs: {
    title: 'Partsflow | Catálogos',
    description: 'Administra las credenciales de tus catálogos',
  },
  settings_widget: {
    title: 'Partsflow | Widget',
    description: 'Configura el widget de cotización y chat web',
  },
  'downloads_product-requests': {
    title: 'Partsflow | Descargas: Solicitudes productos',
    description: 'Review and download commercial data.',
  },
  'downloads_pending-quotes': {
    title: 'Partsflow | Descargas: Repuestos por cotizar',
    description: 'Review and download commercial data.',
  },
  'downloads_out-of-stock': {
    title: 'Partsflow | Descargas: Sin stock',
    description: 'Review and download commercial data.',
  },
  downloads_sales: {
    title: 'Partsflow | Descargas: Ventas',
    description: 'Review and download commercial data.',
  },
  integrations: {
    title: 'Partsflow | Integraciones',
    description: 'Conecta Partsflow con tus canales.',
  },
  issues: {
    title: 'Partsflow | Post venta',
    description: 'Gestión de issues y postventa.',
  },
  news: {
    title: 'Partsflow | Novedades',
    description: 'Novedades y actualizaciones de la plataforma.',
  },
  integrations_widget: {
    title: 'Partsflow | Widget de Cotización Express',
    description: 'Configura el widget de cotización de tu sitio web.',
  },
  integrations_shopify: {
    title: 'Partsflow | Shopify',
    description: 'Conecta tu tienda Shopify con Partsflow.',
  },
  integrations_inventory: {
    title: 'Partsflow | Integración de Inventario',
    description: 'Conecta tu inventario en tiempo real con Partsflow.',
  },
  integrations_tiendanube: {
    title: 'Partsflow | Tiendanube',
    description: 'Conecta tu tienda Tiendanube con Partsflow.',
  },
  integrations_vtex: {
    title: 'Partsflow | VTEX',
    description: 'Conecta tu tienda VTEX con Partsflow.',
  },
  integrations_jumpseller: {
    title: 'Partsflow | Jumpseller',
    description: 'Conecta tu tienda Jumpseller con Partsflow.',
  },
  integrations_repartes: {
    title: 'Partsflow | Repartes',
    description: 'Conecta tu cuenta del marketplace Repartes con Partsflow.',
  },
  repartes_sales: {
    title: 'Partsflow | Ventas Repartes',
    description: 'Ventas pagadas del marketplace Repartes.',
  },
  repartes_wallet: {
    title: 'Partsflow | Wallet Repartes',
    description: 'Saldo, movimientos y retiros del wallet Repartes.',
  },
};

export function getMetadataForPage(pageKey: string) {
  const defaultMetadata = {
    title: 'Partsflow | AI CRM Whatsapp Backoffice',
    description: 'Partsflow AI CRM Whatsapp Backoffice platform',
  };

  let selectedMetadata = metadataDictionary[pageKey] || defaultMetadata;

  selectedMetadata = {
    ...selectedMetadata,
    icons: {
      icon: '/favicon.ico',
      apple: '/apple-touch-icon.png',
    },
  };

  return selectedMetadata;
}

export type GlobalFailureStoreType = {
  send_message_failures: number;
  search_chat_failures: number;
  mark_unread_failures: number;
  message_history_failures: number;
  _listeners: Array<(failureStore: GlobalFailureStoreType) => void>;
  subscribe: (listener: (failureStore: GlobalFailureStoreType) => void) => void;
  unsubscribe: (
    listener: (failureStore: GlobalFailureStoreType) => void
  ) => void;
  notify: VoidFunction;
};

export const GlobalFailureStore: GlobalFailureStoreType = {
  send_message_failures: 0,
  search_chat_failures: 0,
  mark_unread_failures: 0,
  message_history_failures: 0,
  _listeners: [],
  subscribe(listener) {
    this._listeners.push(listener);
  },
  notify() {
    this._listeners.forEach((listener) => listener(this));
  },
  unsubscribe(listenerToRemove) {
    this._listeners = this._listeners.filter(
      (listener) => listener !== listenerToRemove
    );
  },
};
